function IconAntifraudeAprovada(props) {
  return (
    <svg 
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    width={props.width ? props.width : '25'}
    height={props.height ? props.height : '25'}
    fill="none"
    style={{ paddingRight: props.paddingRight }}
    >
      <path 
        fill={props.color ? props.color : '#00BA82'}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 7L9 19l-5.5-5.5l1.41-1.41L9 16.17L19.59 5.59z"
      />
    </svg>

  );
}

export default IconAntifraudeAprovada;
